module.exports = __webpack_public_path__ + "img/nature_citrone_newer-mob.7a6fda50.png";